import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinbandrakurla() {



  const cardData =
  {
    keyword: ' Corporate Cab Services in Bandra Kurla Complex',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Bandra Kurla Complex',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Corporate Cab Services in Bandra Kurla Complex, serving the transportation needs of major corporate offices, financial institutions, and business centers in the area. Our fleet of premium sedans, SUVs, and executive vehicles ensures comfortable, safe, and punctual travel for employees, clients, and senior management. Whether it is daily office commute, airport transfers, business meetings, inter-office travel, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for companies operating in and around Bandra Kurla Complex.',

    top: 'Top Places to Visit in Bandra with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Bandra Kurla Complex (BKC)",
      "description": "Bandra Kurla Complex is Mumbai’s premier financial and commercial district, home to multinational corporations, consulates, global banks, Fortune 500 headquarters, and luxury business hotels. The area includes iconic business towers such as Jio World Centre, Naman Chambers, and The Capital. BKC is the top hotspot for corporate meetings, high-profile events, executive travel, and airport transfers—making it one of the busiest destinations for corporate cab services."
    },
    {
      "title": "Lower Parel Corporate Hub",
      "description": "Lower Parel is Mumbai’s most dynamic corporate zone, combining high-rise office towers like One Indiabulls Centre, Peninsula Business Park, and Lodha World Towers. The area is filled with premium coworking spaces, studios, business hotels, and award-winning restaurants. With its mix of creative agencies, finance companies, and MNCs, Lower Parel demands fast, reliable corporate commuting throughout the day."
    },
    {
      "title": "Nariman Point Business District",
      "description": "Nariman Point is one of India’s oldest and most prestigious business districts, housing corporate headquarters, legal firms, government offices, and international consulates. Overlooking the Marine Drive seafront, it contains iconic commercial towers like Air India Building and Maker Chambers. High-density office traffic makes Nariman Point a prime route for corporate cab travel, especially during peak office hours."
    },
    {
      "title": "Andheri MIDC & SEEPZ",
      "description": "Andheri MIDC and SEEPZ SEZ are major industrial and tech zones in Mumbai, home to IT companies, export houses, manufacturing units, and global service providers. With thousands of employees working across multiple shifts, this zone witnesses high demand for employee transportation, shift-based staff travel, and corporate shuttle services throughout the day."
    },
    {
      "title": "Goregaon Nesco Business Park",
      "description": "Nesco IT Park in Goregaon East has become a major commercial destination with modern office towers, convention centers, and large corporate campuses. It hosts companies in IT, finance, BFSI, and media industries. Its proximity to the Western Express Highway and large employee base makes it one of the most active hubs for corporate cab requirements and executive travel."
    },
    {
      "title": "Powai Hiranandani Business District",
      "description": "Powai’s Hiranandani Business Park is a premium corporate environment featuring modern office complexes, luxury residences, and scenic surroundings. It hosts companies like Nomura, CRISIL, Deloitte, and JP Morgan. The area is known for high-end corporate travel, airport pickups, client meeting routes, and executive chauffeur services due to its professional working crowd."
    },
    {
      "title": "Vikhroli Godrej Business District",
      "description": "Vikhroli is home to the massive Godrej Business Park along with multiple commercial towers, IT campuses, and research facilities. Surrounded by greenery and located close to eastern business zones, it is a preferred location for tech firms and innovation centers. The daily movement of employees and corporate visitors creates consistent demand for premium mobility services."
    },
    {
      "title": "Andheri East Corporate Zone",
      "description": "Andheri East is Mumbai’s largest corporate cluster, packed with commercial towers like Solitaire Corporate Park, Ackruti Star, Times Square, and Hubtown Solaris. Its strategic location near Mumbai Airport makes it a hotspot for business travelers, frequent flyers, and client visits. Corporate cab services play a crucial role in daily commutes, airport drops, and inter-office travel."
    },
    {
      "title": "Malad Mindspace IT Park",
      "description": "Mindspace Malad is one of Mumbai’s biggest IT parks, hosting thousands of professionals working in tech, BPO, and corporate services. With companies like Amazon, Accenture, and JP Morgan operating here, the area runs round-the-clock mobility needs including daily office travel, night shift employee transportation, and executive cab services."
    },
    {
      "title": "Thane Ghodbunder Corporate Belt",
      "description": "Ghodbunder Road in Thane has rapidly grown into a major business corridor with IT parks, commercial complexes, and premium office towers. Corporate hubs like G:Corp, Orion Business Park, and TCS Olympus Centre bring huge employee footfall. It is well-connected to Mumbai, Navi Mumbai, and Thane, making it a high-demand route for corporate taxi and staff transportation services."
    }
  ],


"services": [
{
"name": "BKC Corporate Cabs",
"description": "BKC Corporate Cabs provides professional taxi services for corporate employees, executives, and office staff in the Bandra Kurla Complex (BKC) area. The service ensures comfortable, safe, and punctual transportation with well-maintained vehicles, trained chauffeurs, GPS tracking, and structured routes for office commutes, business trips, and client visits."
},
{
"name": "Bandra Kurla Staff Shuttle",
"description": "Bandra Kurla Staff Shuttle offers multi-passenger shuttle services for office and industrial employees in BKC. With trained drivers, GPS-enabled vehicles, optimized routes, and multi-shift scheduling, the service provides safe, reliable, and efficient daily commuting solutions for corporate staff."
},
{
"name": "BKC Employee Transport",
"description": "BKC Employee Transport delivers structured and dependable transportation for employees working in BKC offices and IT parks. The service includes punctual pickups, professional drivers, GPS tracking, and well-maintained vehicles to ensure seamless and safe daily commuting across the business district."
},
{
"name": "Company Cab BKC Mumbai",
"description": "Company Cab BKC Mumbai provides dedicated corporate cab solutions for office employees, executives, and IT staff. The service features structured daily schedules, GPS-enabled vehicles, professional drivers, and comfortable seating to ensure reliable and stress-free commuting in BKC."
},
{
"name": "BKC Office Pickup Drop",
"description": "BKC Office Pickup Drop offers organized employee transport services for daily office commuting. The service emphasizes punctuality, safety, trained chauffeurs, and optimized multi-route planning to cater to corporate employees and staff across BKC Mumbai."
},
{
"name": "Business Taxi BKC",
"description": "Business Taxi BKC delivers premium corporate taxi services for business executives, office staff, and client visits. With GPS tracking, professional drivers, well-maintained vehicles, and timely pickups, the service ensures efficient and comfortable corporate travel within and outside BKC."
},
{
"name": "Corporate Fleet BKC",
"description": "Corporate Fleet BKC provides fully managed fleet solutions including sedans, SUVs, and shuttle vans for corporate and office transport. The service includes driver management, vehicle maintenance, GPS monitoring, and route optimization to ensure seamless, safe, and reliable employee commuting across BKC."
},
{
"name": "Monthly Cab BKC",
"description": "Monthly Cab BKC offers long-term cab rental solutions for businesses requiring consistent employee transport. The service provides structured monthly plans, trained drivers, GPS-enabled vehicles, and optimized routes to ensure punctual, safe, and comfortable commuting for office staff."
},
{
"name": "Affordable Corporate Cab BKC",
"description": "Affordable Corporate Cab BKC delivers cost-effective corporate transportation services for office employees and executives. The service features reliable pickups, well-maintained vehicles, trained chauffeurs, GPS tracking, and structured daily schedules for safe and efficient commuting at competitive rates."
},
{
"name": "BKC Chauffeur Service",
"description": "BKC Chauffeur Service provides professionally driven vehicles for executives, VIP clients, and corporate employees. The service emphasizes comfort, safety, punctuality, and discretion, ensuring a premium commuting experience for office travel, business meetings, and client visits in BKC Mumbai."
},
{
"name": "BKC Outstation Taxi",
"description": "BKC Outstation Taxi delivers reliable long-distance corporate and employee transportation solutions from BKC. The service includes GPS-enabled vehicles, trained drivers, comfortable seating, and optimized routes to ensure safe, punctual, and hassle-free outstation commuting for business trips and intercity travel."
},
{
"name": "Best Corporate Cabs BKC Mumbai",
"description": "Best Corporate Cabs BKC Mumbai offers top-quality corporate taxi services for office staff, executives, and business travel. The service provides professional drivers, GPS-monitored vehicles, structured routes, and punctual pickups to ensure a seamless and premium commuting experience in BKC."
},
{
"name": "Executive Cab BKC",
"description": "Executive Cab BKC provides premium sedans and SUVs for corporate executives, VIPs, and business clients. The service emphasizes punctuality, professional chauffeurs, GPS tracking, and well-maintained vehicles to ensure comfortable, safe, and reliable commuting within and around BKC Mumbai."
},
{
"name": "Corporate Shuttle BKC",
"description": "Corporate Shuttle BKC delivers organized shuttle services for bulk staff transportation in BKC. The service features multi-passenger vans, trained drivers, GPS-enabled vehicles, optimized routes, and multi-shift support for seamless employee mobility across corporate offices."
},
{
"name": "IT Park Cab BKC",
"description": "IT Park Cab BKC provides dedicated cab services for IT park employees and corporate staff in BKC. The service ensures timely pickups, structured routes, GPS tracking, and trained chauffeurs, offering safe, efficient, and comfortable daily commuting solutions."
}
],

"tableData": [
["BKC Corporate Cabs", "Bandra Kurla Staff Shuttle"],
["BKC Employee Transport", "Company Cab BKC Mumbai"],
["BKC Office Pickup Drop", "Business Taxi BKC"],
["Corporate Fleet BKC", "Monthly Cab BKC"],
["Affordable Corporate Cab BKC", "BKC Chauffeur Service"],
["BKC Outstation Taxi", "Best Corporate Cabs BKC Mumbai"],
["Executive Cab BKC", "Corporate Shuttle BKC"],
["IT Park Cab BKC", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Bandra Kurla Complex",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Bandra Kurla Complex, ensuring smooth and efficient transportation for employees and executives."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee on-time pickups and drops, helping corporate staff reach offices, meetings, and business hubs in Bandra Kurla Complex efficiently."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure corporate commutes."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and designed for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the commuting requirements of businesses and employees in Bandra Kurla Complex."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]































  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Bandra Kurla Complex (BKC)?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable corporate cab services for companies and employees in BKC, Mumbai.',
  },
  {
    question: 'What types of corporate cab services are available in BKC?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions.',
  },
  {
    question: 'Do you support daily commuting for BKC employees?',
    answer: 'Yes, we offer daily commute solutions with optimized routes, timely pickups, and flexible shift scheduling for BKC offices.',
  },
  {
    question: 'How can companies book corporate cab services in BKC?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers to meet corporate needs in BKC.',
  },
  {
    question: 'Can companies avail monthly or long-term cab contracts in BKC?',
    answer: 'Yes, we provide flexible monthly, quarterly, and annual contracts with transparent pricing.',
  },
  {
    question: 'Are safety and tracking features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees in BKC?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in BKC?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Deshmukh',
    feedback: 'Professional and reliable corporate cab service in BKC. Timely pickups and well-maintained vehicles.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Riddhi Mehta',
    feedback: 'Excellent service for employee transportation in BKC. Punctual, safe, and hassle-free.',
    rating: 5,
  },
];



























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Bandra Kurla Complex (BKC)",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-bkc.jpg", // replace with real image URL
  "description": "Pune Corporate Cars India Private Limited provides premium corporate cab services in Bandra Kurla Complex (BKC), covering employee transportation, office pickup & drop, business travel, monthly cabs, corporate shuttles, IT park mobility, and chauffeur-driven executive cars for companies operating in the BKC Mumbai business district.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400", 
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-bkc"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in BKC | Bandra Kurla Complex Corporate Cabs</title>

  <meta
    name="description"
    content="Premium corporate cab services in Bandra Kurla Complex (BKC) including employee transport, office pickup & drop, business travel, monthly corporate cabs, staff shuttles, and chauffeur-driven executive cars. Reliable and professional service for companies in BKC."
  />

  <meta
    name="keywords"
    content="BKC Corporate Cabs, Bandra Kurla Staff Shuttle, BKC Employee Transport, Company Cab BKC Mumbai, BKC Office Pickup Drop, Business Taxi BKC, Corporate Fleet BKC, Monthly Cab BKC, Affordable Corporate Cab BKC, BKC Chauffeur Service, BKC Outstation Taxi, Best Corporate Cabs BKC Mumbai, Executive Cab BKC, Corporate Shuttle BKC, IT Park Cab BKC"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinbandrakurla;